import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { filter } from 'rxjs';
import { MenuColorScheme } from '../interfaces/menu-color-scheme.interface';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class RoutingEventsService {
  constructor(
    private router: Router,
    private titleService: Title,
    private translationService: TranslocoService,
    private activatedRoute: ActivatedRoute,
    private appService: AppService
  ) {}

  public setupRouterEvents(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleTitleChanges(event);
        this.handleColorSchemeChanges(event);
      });
  }

  private handleTitleChanges(event: NavigationEnd): void {
    if (
      event.url === '/show/pickups/where-is-my-waste' ||
      event.url === '/show/pickups/where-is-operator'
    ) {
      this.titleService.setTitle(
        this.translationService.translate('pickups.location')
      );
      return;
    } else {
      let route = this.getRouteChild(this.activatedRoute);
      route.data.subscribe((data) => {
        const translation = this.translationService.translate(data.title);
        if (data.title == null || translation === data.title) {
          if (this.appService.isPartnerVersion) {
            this.titleService.setTitle('PORTALKLIENTA.COM');
          } else {
            this.titleService.setTitle('EMKA');
          }
        } else {
          this.titleService.setTitle(
            this.translationService.translate(data.title)
          );
        }
      });
    }
  }

  private handleColorSchemeChanges(event: NavigationEnd): void {
    let route = this.getRouteChild(this.activatedRoute);
    route.data.subscribe((data) => {
      if (data.colorScheme == null) {
        this.appService.menuColorScheme = MenuColorScheme.RED;
      } else {
        this.appService.menuColorScheme = data.colorScheme;
      }
    });
  }

  private getRouteChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getRouteChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
